export default __webpack_public_path__ + "static/media/seur.eecf843b.svg";